/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {WebPasskeyUpsellRequest} from '@cash-web/protos/squareup/cash/cashdotapp/app.pb'
import {WebPasskeyUpsellResponse} from '@cash-web/protos/squareup/cash/cashdotapp/app.pb'


export const webPasskeyUpsell = (request:WebPasskeyUpsellRequest, options?: CashRequestOptions) => post<WebPasskeyUpsellRequest, WebPasskeyUpsellResponse>("/2.0/cash/web-passkey-upsell", request, {...options, rejectOnError: true })